var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFailOutlineCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "DCC053D1-AA69-4586-B156-F49324772AC3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Email-Confirmation-failed",
    transform: "translate(-489.000000, -127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Checkin-/-Blue",
    transform: "translate(489.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "currentColor",
    strokeWidth: 2.1,
    opacity: 0.35,
    x: 1.05,
    y: 1.05,
    width: 47.9,
    height: 47.9,
    rx: 23.95
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "currentColor",
    transform: "translate(24.895307, 24.895307) rotate(-45.000000) translate(-24.895307, -24.895307) ",
    points: "12.3953072 22.8119739 37.3953072 22.8119739 37.3953072 26.9786406 12.3953072 26.9786406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-9",
    fill: "currentColor",
    transform: "translate(24.895307, 24.895307) rotate(-315.000000) translate(-24.895307, -24.895307) ",
    points: "12.3953072 22.8119739 37.3953072 22.8119739 37.3953072 26.9786406 12.3953072 26.9786406"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFailOutlineCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/failOutlineCircle.95ea5280.svg";
export { ForwardRef as ReactComponent };